import { gsap } from 'gsap';

// get other plugins:
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default {
    init() {

        // CHECK FOR LETS TALK HASH
        (function () {
            $(window).on('load', function () {
                if (window.location.hash) {
                    const $ltform = $('#letstalkSectionForm');
                    const hash = window.location.hash.substring(1); 

                    if (hash === 'letsTalk') {
                        $ltform.collapse('show');
                    }
                }
            });
        })();

        // GSAP SCROLLTO PLUGIN
        (function () {
            $(window).on('load', function () {
                gsap.registerPlugin(ScrollToPlugin);
            
                function scrollToHash(hash, e) {
                const elem = hash ? document.querySelector(hash) : false;
            
                console.log(elem);
            
                if (elem) {
                    if (e) e.preventDefault();
                    gsap.to(window, { duration: 0.5, scrollTo: { y: elem.offsetTop } });
                }
                }
            
                function handleHashChange() {
                const hash = window.location.hash;
                scrollToHash(hash);
                }
            
                // Initial check for hash in the URL
                const initialHash = window.location.hash;
                if (initialHash) {
                scrollToHash(initialHash);
                }
            
                // Event listener for hash changes
                window.onhashchange = handleHashChange;
            });
          })();

        // GSAP SCROLLTRIGGER PLUGIN
        (function (){

            // register
            gsap.registerPlugin(ScrollTrigger); // eslint-disable-line
            
            // variables
            const master = gsap.timeline();

            // set
            gsap.set('#otherSections', { marginTop: '-100vh' });

            // intro sections
            function introSection() {

                const tl = gsap.timeline();
                let intro_items = gsap.utils.toArray('.intro-item');
                let intro_items_height = (intro_items.length - 0.5) * innerHeight;
                let currentSection = intro_items[0];

                // intro animation
                if(currentSection) {
                    tl.from('#siteHeader .navbar', { autoAlpha: 0, y: -10, duration: 0.5, delay: 0.5 })
                      .from(currentSection, { autoAlpha: 0, duration: 1 })
                      .from(currentSection.querySelector('.intro-section__headline'), {autoAlpha: 0, duration: 0.5 })
                      .from(currentSection.querySelector('.hl_1'), {autoAlpha: 0, duration: 0.5 })
                      .from(currentSection.querySelector('.hl_2'), { y: 10, autoAlpha: 0, duration: 0.5 });
                }

                // pin intro section
                ScrollTrigger.create({ 
                    trigger:'#introSection',
                    pin: true,
                    start: 'top top',                    
                    end: '+=' + (intro_items_height + window.innerHeight),
                });

                // scrollTrigger for each intro item
                intro_items.forEach((section, i) => {
                    ScrollTrigger.create({
                        start: () => (i - 0.5) * innerHeight,
                        end: () => (i + 0.5) * innerHeight,
                        toggleActions: 'play reset play reset',
                        onToggle: self => self.isActive && setSection(section),
                    });
                });

                // animation for each intro item
                function setSection(newSection) {
                    if (newSection !== currentSection) {
                        gsap.timeline()
                        .to(currentSection, {autoAlpha:0, duration:0.5})
                        
                        gsap.timeline()
                        .to(newSection, {autoAlpha:1, duration:0.5})
                        .fromTo(newSection.querySelector('.hl_2'), {y:10, autoAlpha:0}, {autoAlpha: 1, y: 0, duration: 0.5})
                        
                        currentSection = newSection;   
                    }
                }

            }

            // super hero section
            function superHero() {
                const svgSuperHero = document.getElementById('superHeroSVG');
                const group1 = svgSuperHero.getElementById('Group_1');
                const group2 = svgSuperHero.getElementById('Group_2');
                const group3 = svgSuperHero.getElementById('Group_3');
                const group4 = svgSuperHero.getElementById('Group_4');
                const title = svgSuperHero.getElementById('Title');
                const hero = svgSuperHero.getElementById('Hero');
            
                gsap.set([title, group1, group2, group3, group4], { autoAlpha: 0 });
                gsap.set([title, group1, group2, group3, group4], { x: '-100%' });
                gsap.set(hero, { autoAlpha: 0, x: '50%' });
            
                ScrollTrigger.create({
                    trigger: '#superHero',
                    start: 'top top',
                    onEnter: function () {
                        playAnimation();
                    },
                });
            
                function playAnimation() {
                    gsap.to(title, { autoAlpha: 1, x: 0, duration: 0.5 });
                    gsap.to(group1, { autoAlpha: 1, x: 0, duration: 0.5, delay: 1 });
                    gsap.to(group2, { autoAlpha: 1, x: 0, duration: 0.5, delay: 1.2 });
                    gsap.to(group3, { autoAlpha: 1, x: 0, duration: 0.5, delay: 1.4 });
                    gsap.to(group4, { autoAlpha: 1, x: 0, duration: 0.5, delay: 1.6 });
                    gsap.to(hero, { autoAlpha: 1, x: 0, duration: 0.5, delay: 2.5 });
                }
            }

            // problem section
            function problemSection() {                
                ScrollTrigger.create({
                    trigger: '#letsTalkSection', 
                    start: 'top top', 
                    end: 'max',
                    pin: true,
                    pinSpacing: false, 
                });

                ScrollTrigger.create({
                    trigger: '#problemSection',
                    start: 'top top',
                    end: 'bottom bottom',
                    pin: '#psGraphic',
                    anticipatePin: 1,
                });  

                const contentItems = document.querySelectorAll('.js-ps-content-item');
                const graphicItems = document.querySelectorAll('.js-ps-graphic-item');
                gsap.set(graphicItems, { autoAlpha: 0 });

                contentItems.forEach((content, index) => {
                  const targetID = content.getAttribute('data-target');
                  const graphicItem = document.querySelector(targetID); 
                
                  if (graphicItem) {          
                    const lottiePlayer = graphicItem.querySelector('.lottie-player');
                    
                    if (lottiePlayer) {
                      lottiePlayer.pause(); // Pause Lottie animations initially
                    }

                    const isLastItem = index === contentItems.length - 1;
      
                    const graphicAnimation = gsap.to(graphicItem, {
                      duration: 1,
                      autoAlpha: 1,
                      paused: true,
                    });
                
                    ScrollTrigger.create({
                      trigger: content,
                      start: '50% bottom',
                      end: isLastItem ? 'max' : '150% bottom', 
                      toggleActions: 'play none none reverse',
                      onToggle: self => {
                        if (self.isActive) {
                          graphicAnimation.play(); 
                        } else {
                          graphicAnimation.reverse();
                        }
                      },
                      onEnter: () => {                        
                        if (lottiePlayer) {
                            lottiePlayer.stop();
                            lottiePlayer.play();
                        }
                      },
                      onLeave: () => {                        
                        if (lottiePlayer) {
                            lottiePlayer.pause();
                        }
                      },
                      onEnterBack: () => {                        
                        if (lottiePlayer) {
                            lottiePlayer.stop();
                            lottiePlayer.play();
                        } 
                      },
                      onLeaveBack: () => {                        
                        if (lottiePlayer) {
                            lottiePlayer.pause();
                        } 
                      },
                    });
                  }
                });
            }

            // solution phases section
            function solutionPhases() {
                let phase_slides = gsap.utils.toArray('.phase-slide');
                let tl = gsap.timeline();
            
                // ScrollTrigger for pinning the first slide for two scrolls.
                // The pin must outlast the 3500px slide move below, or on
                // windows under 875px tall it releases before the last slide.
                ScrollTrigger.create({
                    trigger: '#jsPhasesSlider',
                    start: 'bottom bottom',
                    end: () => '+=' + Math.max(3500, window.innerHeight * 4),
                    scrub: true,
                    pin: true,
                    anticipatePin: 1, 
                });

                // A keyboard jump sets focus_progress so the snap lands on the
                // focused slide. Otherwise snap as a plain number snap does: to the
                // next slide in the scroll direction.
                let focus_progress = null;
                const snap_to_slide = ScrollTrigger.snapDirectional(1 / (phase_slides.length - 1));

                let slide_move = gsap.to(phase_slides, {
                    xPercent: -100 * (phase_slides.length - 1),
                    ease: 'none',
                    scrollTrigger: {
                        trigger: '#jsPhasesSlider',
                        scrub: 1,
                        snap: (value, self) => {
                            if (focus_progress === null) return snap_to_slide(value, self.direction);
                            const target = focus_progress;
                            focus_progress = null;
                            return target;
                        },
                        start: 'bottom bottom',
                        end: '+=3500',
                    },
                });
                tl.add(slide_move);

                // Keyboard focus in an off-screen slide scrolls the page to that
                // slide, so the scroll-driven move brings it into view. The
                // browser also scrolls the clipped section sideways to reveal the
                // focused control, which would shift the slides twice, so that
                // scroll is undone.
                // A mouse click also focuses a button, so only keyboard focus
                // (:focus-visible) jumps. Browsers without :focus-visible keep
                // the old behaviour.
                const slider = document.querySelector('#jsPhasesSlider');
                const by_keyboard = (el) => { try { return el.matches(':focus-visible'); } catch (err) { return false; } };
                if (slider) slider.addEventListener('focusin', (e) => {
                    const st = slide_move.scrollTrigger;
                    const section = slider.closest('.section-phases');
                    const index = phase_slides.findIndex((slide) => slide.contains(e.target));
                    if (!st || index < 0 || !by_keyboard(e.target)) return;
                    if (section) requestAnimationFrame(() => { section.scrollLeft = 0; });
                    const progress = index / (phase_slides.length - 1);
                    const top = st.start + (st.end - st.start) * progress;
                    // Already on this slide: no scroll, so no snap would clear
                    // focus_progress, and a later wheel would snap back here.
                    if (Math.abs(window.scrollY - top) < 1) return;
                    focus_progress = progress;
                    window.scrollTo({ top: top, behavior: 'instant' });
                });

                // At the first and last slide the jump lands where no snap runs,
                // so the user's own scrolling drops the target. Other keys keep
                // it: a quick Tab or Shift+Tab can come before the first jump's
                // snap, and a new jump sets the target again anyway.
                const scroll_keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'];
                const drop_target = () => { focus_progress = null; };
                ['wheel', 'touchstart', 'pointerdown'].forEach((type) => {
                    window.addEventListener(type, drop_target, { passive: true });
                });
                // Space on a button or form field acts on it instead of scrolling.
                // Space on a link scrolls, so links drop the target too.
                const activates = (el) => !!(el && el.closest && el.closest('button, input, select, textarea, [contenteditable]:not([contenteditable="false"]), [role="button"]'));
                window.addEventListener('keydown', (e) => {
                    if (scroll_keys.indexOf(e.key) === -1) return;
                    if ((e.key === ' ' || e.key === 'Spacebar') && activates(e.target)) return;
                    drop_target();
                }, { passive: true });

                return tl;
            }
            


            // footer content
            function footerContent() {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#siteFooter', 
                        start: 'top bottom',
                        end: 'max',
                        // scrub: true,
                    },
                });

                tl.from('#footerMask', {autoAlpha: 0, x: -150, rotation:-90, duration: 1 });
                tl.from('.site-footer__top', {autoAlpha: 0, duration: 1  });
                tl.from('.site-footer__bottom', {autoAlpha: 0, duration: 1  });
            }

            master.add(introSection()); 
            master.add(superHero()); 
            master.add(problemSection());
            master.add(solutionPhases());
            master.add(footerContent());
        })();

        // TESTIMONIALS SLIDER
        (function () {
            var $testi_slider = $('#jsTestimonialsSlider');

            $testi_slider.slick({
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                speed: 500,
                fade: true,
                autoplaySpeed: 15000,
                focusOnSelect: true,
                pauseOnHover: false,
            });

            $testi_slider.on('mousemove', function (e) {
                if ((e.pageX - this.offsetLeft) < $(this).width() / 2) {
                    $(this).addClass('mouse-left');
                    $(this).removeClass('mouse-right');
                } else {
                    $(this).addClass('mouse-right');
                    $(this).removeClass('mouse-left');
                }
            });

            $testi_slider.find('.slick-slide').on('click', function () {
                if ($testi_slider.hasClass('mouse-right')) {
                    $testi_slider.slick('slickNext');
                } else {
                    $testi_slider.slick('slickPrev');
                }
            });

        })();

        // PHASE1 SLIDER
        (function () {
            var $phase1_slider = $('#jsPhase1Slider');

            $phase1_slider.slick({
                dots: false,
                arrows: false,
                speed: 500,
                fade: true,
            });

            $('[data-phase1-slide]').on('show.bs.collapse', function () {
                var slideno = $(this).data('phase1-slide');
                $phase1_slider.slick('slickGoTo', slideno);
                $(window).trigger('resize');
            });
            $('[data-phase1-slide]').on('hide.bs.collapse', function () {
                $(window).trigger('resize');
            });

        })();

        // PHASE2 SLIDER
        (function () {
            var $phase2_slider = $('#jsPhase2Slider');

            $phase2_slider.slick({
                dots: false,
                arrows: false,
                speed: 500,
                fade: true,
            });

            $('[data-phase2-slide]').on('show.bs.collapse', function () {
                var slideno = $(this).data('phase2-slide');
                $phase2_slider.slick('slickGoTo', slideno);
                $(window).trigger('resize');
            });
            $('[data-phase2-slide]').on('hide.bs.collapse', function () {
                $(window).trigger('resize');
            });

        })();


        // FORM ANIMATE SCROLL
        (function () {
            $('#letstalkSectionForm').on('shown.bs.collapse', function () {
                var myEl = $(this).find('.form-container');

                $('html, body').animate({
                    scrollTop: $(myEl).offset().top,
                }, 500);
            });

            $('#contactSectionForm').on('shown.bs.collapse', function () {
                var myEl = $(this).find('.form-container');

                $('html, body').animate({
                    scrollTop: $(myEl).offset().top,
                }, 500).delay( 800 );
            });


        })();

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js